import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { InstallPrompt } from "@/components/InstallPrompt";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Referrals from "@/pages/Referrals";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Onboarding from "@/pages/Onboarding";
import Login from "@/pages/Login";
import Feed from "@/pages/Feed";
import RecallDetail from "@/pages/RecallDetail";
import Settings from "@/pages/Settings";
import Unsubscribed from "@/pages/Unsubscribed";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import BlogAuthor from "@/pages/BlogAuthor";
import BlogCategory from "@/pages/BlogCategory";
import BlogPreview from "@/pages/BlogPreview";
import "@/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/referrals" element={<Referrals />} />
        <Route path="/join" element={<Onboarding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/alerts" element={<Feed />} />
        <Route path="/recall/:id" element={<RecallDetail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/unsubscribed" element={<Unsubscribed />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/author/:slug" element={<BlogAuthor />} />
        <Route path="/blog/category/:slug" element={<BlogCategory />} />
        <Route path="/blog/preview/:token" element={<BlogPreview />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" />
      <InstallPrompt />
    </BrowserRouter>
  );
}
